<script>
import { mapGetters } from 'vuex'
import { demo } from '@/mixins/demo'
import IconBase from '@/components/_common/icons/IconBase'
import LoginIcon from '@/components/_common/icons/library/LoginIcon'
import brochureHeader from '@/graphql/query/brochureHeader.graphql'
export default {
  name: 'TheNav',
  components: {
    IconBase,
    LoginIcon
  },
  mixins: [demo],
  computed: {
    ...mapGetters({
      libraryInfo: 'brochure/libraryInfo',
      workingLibrary: 'ovb/workingLibrary',
      // guestUserInfo: 'brochure/guestUserInfo',
      licensePlans: 'brochure/licensePlans',
      pricingTag: 'brochure/pricingTag',
      isHomeProgram: 'brochure/isHomeProgram',
      isBrainRehab: 'brochure/isBrainRehab'
    }),
    libraryOptions () {
      return this.libraryInfo.map(o => {
        return {
          ...o,
          value: o.id,
          selected: (o.id === this.workingLibrary.id),
          label: o.id === 'vision' ? 'Vision Therapy' : `${o.name} Therapy`
        }
      })
    },
    showBernellNav () {
      const partnerCode = (typeof this.pricingTag === 'string') ? this.pricingTag.toLowerCase() : null
      return (partnerCode === 'bernell')
    },
    hideTopNav () {
      return (this.$route.path === '/brain-rehab-home')
    }
  },
  methods: {
    loginWithRedirect () {
      window.location.href = process.env.VUE_APP_LOGIN_URL || 'https://play.ourvisualbrain.com/login'
    }
  },
  created () {
    this.$eventHub.$on('SHOW_FREE_TRIAL', this.onShowFreeTrial)
  },
  apollo: {
    plans: {
      query: brochureHeader,
      loadingKey: 'loading',
      update (data) {
        const licensePlans = {
          vision: data.vision,
          occupational: data.occupational
        }
        this.$store.dispatch('brochure/setLicensePlans', licensePlans)
        this.$store.dispatch('brochure/setLibraryInfo', data.libraryInfo.libraries)
        if (!this.workingLibrary) {
          const defaultLib = data.libraryInfo.libraries.find(o => o.id === 'vision')
          this.$store.dispatch('SET_WORKING_LIBRARY', defaultLib)
        }
      }
    }
  }
}
</script>

<template>
  <b-navbar
    class="the-nav"
    :shadow="false"
    :spaced="false"
    :fixed-top="true"
    :centered="true"
    v-if="!hideTopNav"
  >
    <template #brand>
      <template v-if="!isBrainRehab">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            class="ovb-logo"
            :src="require('@/assets/promo/img/OVB_logo_gray.svg')"
            alt="Our Visual Brain home"
          >
        </b-navbar-item>
      </template>
      <template v-else>
        <b-navbar-item tag="router-link" :to="{ path: '/brain-rehab' }">
          <img
            class="ovb-logo"
            :src="require('@/assets/promo/img/OVB_logo_gray.svg')"
            alt="Our Visual Brain: Brain Rehab home"
          >
        </b-navbar-item>
      </template>
    </template>
    <template #start>
      <template v-if="!isBrainRehab">
        <b-navbar-item
          exact-path
          v-if="!isBrainRehab"
          tag="router-link"
          :to="{ name: 'HomeView', params: {stickyNav: true}}"
        >
          Home
        </b-navbar-item>
      </template>
      <template v-else>
        <b-navbar-item
          v-if="!isBrainRehab"
          tag="router-link"
          exact-path
          :to="{ name: 'BrainRehab', params: {stickyNav: true}}"
        >
          Home
        </b-navbar-item>
      </template>
      <template v-if="!isHomeProgram && !isBrainRehab">
        <b-navbar-item
          tag="router-link"
          exact
          :to="{ name: 'FeaturesView', params: {stickyNav: true}}"
        >
          Features
        </b-navbar-item>
      </template>
      <template v-if="!isBrainRehab">
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'ActivitiesView', params: {stickyNav: true}}"
        >
          Activities
        </b-navbar-item>
      </template>
      <template v-if="showBernellNav">
        <b-navbar-item
          exact-path
          tag="router-link"
          :to="{ path: '/partners/bernell', params: {stickyNav: true}}"
        >
          Bernell Plans
        </b-navbar-item>
      </template>
      <template v-if="!showBernellNav && !isHomeProgram && !isBrainRehab">
        <b-navbar-item
          exact-path
          tag="router-link"
          :to="{ name: 'PlansView', params: {stickyNav: true}}"
        >
          Plans
        </b-navbar-item>
      </template>
      <template v-if="!isBrainRehab">
        <b-navbar-item
          exact-path
          tag="router-link"
          :to="{ name: 'AboutView', params: {stickyNav: true}}"
        >
          About
        </b-navbar-item>
      </template>
      <b-navbar-item
        tag="router-link"
        :to="{ name: 'ContactView', params: {stickyNav: true}}"
      >
        Contact
      </b-navbar-item>
      <template v-if="!isBrainRehab">
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'StoreView', params: {stickyNav: true}}"
        >
          Bookstore
        </b-navbar-item>
      </template>

    </template>
    <template #end>
      <b-navbar-item
          tag="a"
          tabindex="0"
          class="button-reset"
          @click="loginWithRedirect"
      >
        <span>Reset</span>
      </b-navbar-item>
      <b-navbar-item
        tag="a"
        tabindex="0"
        class="button-login"
        @click="loginWithRedirect"
      >
        <icon-base :width="32" :height="32" aria-hidden="true">
          <login-icon />
        </icon-base>
        <span>Login</span>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<style lang="scss" scoped>
.ovb-logo {
  display: block;
  min-width: 13rem;
  @include tablet {
    min-width: 13rem;
  }
  @include desktop {
    min-width: 14rem;
  }
}
.button-login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  &:hover {
    //color: $primary;
    //background-color: $white;
  }
}
.button-reset {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: $gray-light !important;
  &:hover {
    color: $charcoal !important;
    //background-color: $white;
  }
  @include desktop {
    color: $eggshell !important;
    &:hover {
      color: $charcoal !important;
      //background-color: $white;
    }
  }
}
//.button-login {
//  display: flex;
//  align-items: center;
//  justify-content: center;
//  flex-grow: 1;
//  height: 100%;
//  &:hover {
//    background-color: $white;
//  }
//}
</style>
<style lang="scss" >
.navbar.the-nav {
  background-color: $white-50;
  backdrop-filter: blur(8px);
  z-index: 99;
  min-height: auto;
  .navbar-brand .navbar-item {
    padding-left: 1rem;
  }
  .navbar-item {
    color: $text;
    font-size: $size-5;
    &:hover, &:focus {
      filter: saturate(3);
    }
    &.login-container {
      padding-right: 1rem;
    }
  }
  .text-outline {
    filter: url('#outline');
  }
  .navbar-burger {
    width: 4rem;
    height: 4rem;
  }
  .navbar-brand, .navbar-tabs {
    min-height: auto;
  }
  .navbar-item img {
    max-height: none;
  }
  .router-link {
    &-active {
      color: $watermelon;
    }
  }
}
</style>
